import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "cutText",
})
export class CutTextPipe implements PipeTransform {
  transform(str: string, maxLength: number = 10): string {
    if(!str) str = '';
    if (str.length <= maxLength) return str;

    // Cut at maxLength
    let cut = str.substr(0, maxLength);

    // Ensure we don't cut in the middle of a word
    if (str[maxLength] !== " " && cut.lastIndexOf(" ") > -1) {
      cut = cut.substr(0, cut.lastIndexOf(" "));
    }

    return cut + "..."; // optional, indicate truncation
  }
}
